<script setup>
import { onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { Calendar } from 'vant'
import { getAnswer } from '@/utils/tools'

const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
  currentChecked: {
    type: String,
    default: '',
  },
  // 临时处理答题个人题型必填显示
  showAnswerRequired: {
    type: Number,
    default: 0,
  },
  isReview: {
    type: Boolean,
    default: false,
  },
  quesIndex: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['dateSelect'])

const currentData = ref('')

const showCalendar = ref(false)
function handleCalendarConfirm(value) {
  showCalendar.value = false
  currentData.value = dayjs(value).format('YYYY年MM月DD日')
  emit('dateSelect', {
    value: dayjs(value).format('YYYY-MM-DD'),
    type: 'input',
    optionKey: props.data.optionVoList[0].optionKey,
    questionKey: props.data.questionKey,
    questionType: props.data.questionType,
  })
}

onMounted(() => {
  const localAnswer = getAnswer(props.data.questionKey)
  if (localAnswer) {
    handleCalendarConfirm(localAnswer?.[0].answerContent)
  }
})
</script>
<template>
  <div>
    <h1
      class="choice-title"
      :class="{
        required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
      }"
    >
      <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
        `${quesIndex + 1}、`
      }}</span
      >{{ data?.title }}
    </h1>
    <div @click="showCalendar = true" class="choice">
      <div class="choice-item">{{ currentData || '请选择' }}</div>
    </div>

    <Calendar
      v-model:show="showCalendar"
      :min-date="new Date(1900)"
      color="#1989fa"
      @confirm="handleCalendarConfirm"
    />
  </div>
</template>
